import { useEffect } from "react";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { TrustStrip } from "@/components/TrustStrip";
import { HowItWorksRenters, HowItWorksHosts } from "@/components/HowItWorks";
import { Verification } from "@/components/Verification";
import { HostPricing } from "@/components/HostPricing";
import { RenterPricing } from "@/components/RenterPricing";
import { Localities } from "@/components/Localities";
import { LeadForm } from "@/components/LeadForm";
import { FAQ, FAQ_ITEMS } from "@/components/FAQ";
import { Footer } from "@/components/Footer";
import { StickyBar } from "@/components/StickyBar";
import { useStats } from "@/hooks/useStats";
import { scrollToLeadForm } from "@/lib/scroll";

export default function Landing() {
  const stats = useStats();

  useEffect(() => {
    document.title = "NightBay — Monthly Overnight Car Parking in Bengaluru";
    if (window.location.hash === "#lead") {
      const intent = new URLSearchParams(window.location.search).get("intent");
      requestAnimationFrame(() => scrollToLeadForm(intent || undefined));
    }
    const el = document.createElement("script");
    el.type = "application/ld+json";
    el.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: FAQ_ITEMS.map((i) => ({
        "@type": "Question",
        name: i.q,
        acceptedAnswer: { "@type": "Answer", text: i.a },
      })),
    });
    document.head.appendChild(el);
    return () => document.head.removeChild(el);
  }, []);

  return (
    <div className="App" data-testid="landing-page">
      <Header />
      <main>
        <Hero />
        <TrustStrip stats={stats} />
        <HowItWorksRenters />
        <HowItWorksHosts />
        <Verification />
        <HostPricing stats={stats} />
        <RenterPricing stats={stats} />
        <Localities />
        <LeadForm />
        <FAQ />
      </main>
      <Footer />
      <StickyBar />
    </div>
  );
}
